import { useLocation } from 'react-router-dom';
import { isNextJS } from '@hivebrite/utils';
export const useGetRoutingType = () => {
    let routingType = 'html';
    try {
        useLocation();
        routingType = 'react-router-dom';
    }
    catch (_a) {
        routingType = 'html';
    }
    if (isNextJS()) {
        routingType = 'nextjs';
    }
    return routingType;
};
//# sourceMappingURL=getRoutingType.js.map